import React from 'react';

class WidgetRenderBlock extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'WidgetBlock';
  }
  render() {
    return (<div>
    </div>);
  }
}

export default WidgetRenderBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/widgetRenderBlock.js
 **/